import { render, staticRenderFns } from "./SuccessTransaction.vue?vue&type=template&id=854426ae&scoped=true"
import script from "./SuccessTransaction.vue?vue&type=script&lang=js"
export * from "./SuccessTransaction.vue?vue&type=script&lang=js"
import style0 from "./SuccessTransaction.vue?vue&type=style&index=0&id=854426ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854426ae",
  null
  
)

export default component.exports